import React from 'react';
import {arrayOf, oneOf, bool, func, object, shape, string} from 'prop-types';
import {Link} from 'react-router-dom';
import {Dropdown, Icon, Image, Menu} from 'semantic-ui-react';
import sum from 'lodash/sum';
import MasterSearchBarContainer from 'components/MasterSearchBar/MasterSearchBarContainer';
import AppContext from 'pages/AppContext';

// convenience "enum" for mapping indices to natural language names of numbers (for CSS)
const numbers = [
  'zero',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six'
];

/**
 * Default header for CMS.
 * Contains primary navigation.
 */
class Header extends React.Component {
  static propTypes = {
    allowFeaturedManager: bool,
    allowMaintenance: bool,
    allowPublishLog: bool,
    allowRafflePrizes: bool,
    allowRewardsStore: bool,
    allowUGCModeration: bool,
    allowUserManagement: bool,
    allowHomepageManagement: bool,
    allowSurveyAnswers: bool,
    router: shape({
      history: shape({
        push: func.isRequired
      }).isRequired
    }).isRequired,
    challengeId: string,
    currentPlatform: string,
    activePlatforms: arrayOf(string),
    userPhoto: string,
    lang: oneOf([
      'en-US',
      'es-LA',
      'en-GB'
    ])
  };

  static defaultProps = {
    lang: 'en-US'
  };

  constructor(props, children) {
    super(props, children);

    //State controllers for the custom "Tools" dropdown
    this.state = {
      prizing_DD_Open: false,
      admin_DD_Open: false,
      tools_DD_Open: false,
      kSecret: false,
      logoHover: false,
      userHover: false
    };

    this.kKeys = [38,38,40,40,37,39,37,39,66,65]; //Konami Code
    this.kStart = false;
    this.kCount = 0;

    this.openPrizing = this.openPrizing.bind(this);
    this.openAdmin = this.openAdmin.bind(this);
    this.openTools = this.openTools.bind(this);
    this.closeTools = this.closeTools.bind(this);
    this.resetKCode = this.resetKCode.bind(this);
    this.handleKonami = this.handleKonami.bind(this);
    this.handleLogoHover = this.handleLogoHover.bind(this);
    this.handleUserHover = this.handleUserHover.bind(this);

    var userPhotoInStore = AppContext.persistentStore.getItem("userPhoto") || null;

    if (userPhotoInStore !== null && userPhotoInStore !== "null") {
      this.userPhoto = userPhotoInStore;
    }
    else {
      var userObj = this.props.user;
      this.userPhoto = (userObj.user !== null ? userObj.user.profilePhotoId : null);
      AppContext.persistentStore.setItem("userPhoto", this.userPhoto);
    }

  }

  componentWillMount() {
    document.addEventListener("keydown", this.handleKonami);
  }

  handleKonami(event) {
      var key = event.keyCode;
      //Set start to true only if having pressed the first key in the konami sequence.
      if(!this.kStart){
        if(key == 38){
          this.kStart = true;
        }
      }
      //If we've started, pay attention to key presses, looking for right sequence.
      if(this.kStart){
        if(this.kKeys[this.kCount] == key){
          //We're good so far.
          this.kCount++;
        } else {
          //Oops, not the right sequence, lets restart from the top.
          this.resetKCode();
        }
        if(this.kCount == 10){
          //We made it!
          this.setState({
            kSecret: true
          });

          setTimeout(() => { this.setState({ kSecret: false }) }, 4000); //Run our animation at the length we set in CSS.
          //Reset the conditions so that someone can do it all again.
          this.resetKCode();
        }
      } else {
      //Oops.
        this.resetKCode();
      }
  }

  //Function used to reset us back to kcode starting point.
  resetKCode() {
    this.kStart = false;
    this.kCount = 0;
  	return;
  }

  //Opens/Closes the prizing Sub-dropdown and closes the other dropdowns if they're open.
  openPrizing() {
    this.setState({
      prizing_DD_Open: true,
      admin_DD_Open: false
    });
  }

  //Opens/Closes the Admin Sub-dropdown and closes the other dropdowns if they're open.
  openAdmin() {
    this.setState({
      admin_DD_Open: true,
      prizing_DD_Open: false
    });
  }

  //Open the parent Tools dropdown.
  //NOTE: We have to seperate Open/Close for the parent because of how we handle mouse states.
  openTools() {
    this.setState({tools_DD_Open: true});
  }

  closeTools() {
    this.setState({
      tools_DD_Open: false,
      admin_DD_Open: false,
      prizing_DD_Open: false
    });
  }

  navigateOnClick = route => event => {
    this.props.router.history.push(route);
    this.closeTools();
  };

  handleLogoHover() {
    this.setState({
      logoHover: !this.state.logoHover
    });
  }

  handleUserHover() {
    this.setState({
      userHover: !this.state.userHover
    });
  }

  get prizingClassName() {
    const classes = ['nested-content'];

    if (this.state.prizing_DD_Open) {
      const numItems = sum([
        3,
        this.props.allowRewardsStore ? 1 : 0,
        this.props.allowRafflePrizes ? 1 : 0
      ]);

      const number = numbers[numItems];
      classes.push(`${number}-item${numItems > 1 ? 's' : ''}`);
    }

    return classes.join(' ');
  }

  get adminClassName() {
    const classes = ['nested-content'];

    if (this.state.admin_DD_Open) {
      const numItems = sum([
        this.props.allowPublishLog ? 1 : 0,
        this.props.allowMaintenance ? 1 : 0
      ]);

      const number = numbers[numItems];
      classes.push(`${number}-item${numItems > 1 ? 's' : ''}`);
    }

    return classes.join(' ');
  }

  render() {
    return (
      <section>
        <Menu borderless className={"dashboardHeader onDash"}>
          <Menu.Item>
            <Link to="/">
              <div className="logo-circle-wrapper">
                <Image
                  onMouseEnter={this.handleLogoHover}
                  onMouseLeave={this.handleLogoHover}
                  className={this.state.logoHover ? "anim-sway" : ""}
                  height="57"
                  width="41"
                  centered
                  src={"https://s3.amazonaws.com/beaker-tooltips/beaker-logo-icon-final+(1).svg"} />
              </div>
            </Link>
            <div className={`db-site-icon db-lang-${this.props.lang}`}></div>
            <div className="separator"></div>
          </Menu.Item>
          <Menu.Item position="right" className="db-break-search">
            <MasterSearchBarContainer router={this.props.router} />
          </Menu.Item>
          <Menu.Item onMouseEnter={this.openTools} onMouseLeave={this.closeTools} position="right" className="db-header-dropdown">
            <div className="tools-dropdown">
              <Icon name="setting"/>
              {this.state.tools_DD_Open
                ? <div className="dd-content fadeInUp animQuick" onMouseLeave={this.closeTools}>
                    <Link to="/images" onClick={this.closeTools}>
                      Images
                    </Link>
                    {this.props.allowFeaturedManager && (
                      <a href="https://beaker2.dailybreak.com/#/featured-content" target="_blank" onClick={this.closeTools}>
                        Feature Manager (Beaker2) 
                      </a>
                    )}

                    {/* hide entire sub-menus if user cannot see any of their active items. */}

                    {(this.props.allowRewardsStore || this.props.allowRafflePrizes) && (
                      <div className="nested-dropdown">
                        <div onClick={this.openPrizing}>Prizing <Icon name="dropdown"/></div>
                        <ul className={this.prizingClassName}>
                          {this.props.allowRewardsStore && (
                            <li onClick={this.navigateOnClick("/rewards")}>Dashboard</li>
                          )}
                          {this.props.allowRafflePrizes && (
                            <React.Fragment>
                              <li onClick={this.navigateOnClick("/prizes/sponsored")}>Sponsored Prizes</li>
                              <li onClick={this.navigateOnClick("/prizes/editorial")}>Editorial Sweeps</li>
                            </React.Fragment>
                          )}
                          {this.props.allowWinners && (
                            <li onClick={this.navigateOnClick("/winners/editorial")}>Winners</li>
                          )}
                          <li>Create entry</li>
                        </ul>
                      </div>
                    )}
                    {this.props.allowUGCModeration && (
                      <div onClick={this.navigateOnClick("/ugc")}>UGC moderation</div>
                    )}
                    {this.props.allowUserManagement && (
                      <div onClick={this.navigateOnClick("/users")}>User management</div>
                    )}

                    
                    {(this.props.allowPublishLog || this.props.allowMaintenance) && (
                      <div className="nested-dropdown">
                        <div onClick={this.openAdmin}>Admin <Icon name="dropdown"/></div>
                        <ul className={this.adminClassName}>
                          {this.props.allowPublishLog && (
                            <li>
                              <Link to='/publishlog' onClick={this.closeTools}>
                                Publish Logs
                              </Link>
                            </li>
                          )}
                          {this.props.allowMaintenance && (
                            <li>
                              <Link to='/maintenance' onClick={this.closeTools}>
                                Maintenance
                              </Link>
                            </li>
                          )}
                        </ul>
                      </div>
                    )}
                  </div>
                : ""}
                <div className="separator"/>
            </div>

          </Menu.Item>
          <Menu.Item className="db-header-dropdown">
            {this.userPhoto !== null && this.userPhoto !== undefined ?
              <div className={"user-photo"}>
                <img className={this.state.userHover ? "jello animTime-normal" : ""} src={"https://s3.amazonaws.com/dbugc_prod/" +this.userPhoto}/>
              </div>
              :
            ""}

            <Dropdown floating
                      simple
                      icon="user"
                      className={this.userPhoto !== null && this.userPhoto !== undefined ? "user-dropdown hide": "user-dropdown"}
                      onMouseOver={this.handleUserHover}
                      onMouseLeave={this.handleUserHover}
                      >
              <Dropdown.Menu>
                <Link to="/profile">
                  <Dropdown.Item className="fadeInUp animQuick" text="Profile"/>

                </Link>
                <Dropdown.Item className="fadeInUp animQuick" text="Sign out" onClick={this.props.logout}/>
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>
        </Menu>

          {this.state.kSecret ?
            <img className="contra-dude animKonami" src="https://78.media.tumblr.com/814e377d0825df43900c561f68002d7d/tumblr_n8ics3apgP1s9oln7o1_400.gif"/>
          :""}


      </section>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./public/components/Header/Header.jsx